import React, {useState, useRef, useEffect} from 'react';

import {
  MainContentWrapperStyle,
  ViewMoreTextStyled,
  ContentWrapper,
} from './ContentContainer.styles';

import {scrollToEl} from '@stencil/hotels-utils/src/scroll-into-view-details';

const ContentContainer: React.FC<{
  children: React.ReactNode;
  heightToBeVisible: number;
  scrollToId?: string;
}> = ({children, heightToBeVisible, scrollToId}) => {
  const [showMore, updateShowMore] = useState(false);
  const [visibleContentHeight, updateVisibleContentHeight] = useState();
  const [originalContentHeight, updateOriginalContentHeight] = useState();
  const [showLimitedData, updatesLimitedData] = useState(false);

  const container = useRef();
  const content = useRef();

  const showMoreClickHandler = e => {
    e.preventDefault();
    updateShowMore(!showMore);
    {
      !showMore
        ? updateVisibleContentHeight(originalContentHeight)
        : updateVisibleContentHeight(heightToBeVisible);
    }
    if (scrollToId && showMore) scrollToEl(scrollToId);
  };

  useEffect(() => {
    if (content.current) {
      let contentHeight = content?.current?.offsetHeight;
      updateOriginalContentHeight(contentHeight);
      if (contentHeight > heightToBeVisible) {
        updatesLimitedData(true);
        updateVisibleContentHeight(heightToBeVisible);
      } else {
        updateVisibleContentHeight(contentHeight);
      }
    }
  }, []);

  return (
    <MainContentWrapperStyle ref={container}>
      <ContentWrapper ref={content} height={`${visibleContentHeight}px`}>
        {children}
      </ContentWrapper>

      {!!showLimitedData && (
        <ViewMoreTextStyled onClick={showMoreClickHandler}>
          {showMore ? 'Hide' : 'View More'}
        </ViewMoreTextStyled>
      )}
    </MainContentWrapperStyle>
  );
};

export default ContentContainer;
